import { render } from "./PrivacyPolicy.vue?vue&type=template&id=596bb7c1&ts=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__